import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";
import { Reveal, Eyebrow } from "../Reveal";
import { STATS } from "../../lib/site";

const Counter = ({ value, suffix = "", prefix = "", decimals = 0 }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const start = performance.now();
    const duration = 1800;
    let raf;
    const step = (t) => {
      const p = Math.min((t - start) / duration, 1);
      setVal(value * (1 - Math.pow(1 - p, 3)));
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [inView, value]);

  return (
    <span ref={ref} className="font-display text-4xl sm:text-5xl font-extrabold gradient-accent-text tracking-tight">
      {prefix}
      {val.toFixed(decimals)}
      {suffix}
    </span>
  );
};

export const Stats = () => (
  <section
    id="results"
    data-testid="stats-section"
    className="py-16 sm:py-24 px-4 sm:px-8 lg:px-12 bg-[#070D24] border-y border-white/5 scroll-mt-20"
  >
    <div className="max-w-7xl mx-auto">
      <Reveal className="max-w-2xl space-y-4 mb-12">
        <Eyebrow>Proof, Not Promises</Eyebrow>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white leading-tight">
          Numbers Our Clients <span className="gradient-accent-text">Actually Care About</span>
        </h2>
      </Reveal>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
        {STATS.map((s, i) => (
          <Reveal key={s.label} delay={i * 0.1}>
            <div
              data-testid={`stat-card-${i}`}
              className="glass-card rounded-2xl p-6 sm:p-8 text-center hover:border-blue-500/30 transition-colors duration-300"
            >
              <Counter value={s.value} suffix={s.suffix} prefix={s.prefix || ""} decimals={s.decimals} />
              <p className="mt-3 text-xs sm:text-sm text-slate-400 font-medium">{s.label}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
